import { getFormStepStates } from "../../common/utils/form-utils";
import {UPDATE_FORM_STEP, UPDATE_STEP_10_STATE, UPDATE_STEP_11_STATE, UPDATE_STEP_1_STATE, UPDATE_STEP_2_STATE, UPDATE_STEP_3_STATE, UPDATE_STEP_4_STATE, UPDATE_STEP_5_STATE, UPDATE_STEP_6_STATE, UPDATE_STEP_7_STATE, UPDATE_STEP_8_STATE, UPDATE_STEP_9_STATE } from "../action-types/form";
import FormService from "../services/form";

// *******************************
//  GET USER FORM
// *******************************

export const getUserForm = (userRef) => {
    return dispatch => {
        FormService.getUserForm(userRef).then((response) => {
            const steps = getFormStepStates(response.form.fields);

            dispatch(updateStep1State(steps.step1));
            dispatch(updateStep2State(steps.step2));
            dispatch(updateStep3State(steps.step3));
            dispatch(updateStep4State(steps.step4));
            dispatch(updateStep5State(steps.step5));
            dispatch(updateStep6State(steps.step6));
            dispatch(updateStep7State(steps.step7));
            dispatch(updateStep8State(steps.step8));
            dispatch(updateStep9State(steps.step9));
            dispatch(updateStep10State(steps.step10));
            dispatch(updateStep11State(steps.step11));

            dispatch(updateFormStepSuccess(response.form.fields));
        })
        .catch(error => {
            console.error(error);
        });
    };
}

// *******************************
//  UPDATE FORM STEP
// *******************************

export const updateFormStep = (userRef, stepFields, submitCallback) => {
    return dispatch => {
        FormService.updateUserForm({
            userRef: userRef,
            fields: stepFields
        }).then((response) => {
            dispatch(updateFormStepSuccess(response.form.fields));
            submitCallback();
        })
        .catch(error => {
            console.error(error);
        });
    };
}

export const updateFormStepSuccess = (formFields) => {
    return  {
        type: UPDATE_FORM_STEP,
        formFields: formFields
    };
}

// *******************************
//  UPDATE STEP 1 STATE
// *******************************

export const updateStep1State = (state) => {
    return dispatch => {
        dispatch(updateStep1StateSuccess(state));
    };
}

export const updateStep1StateSuccess = (state) => {
    return  {
        type: UPDATE_STEP_1_STATE,
        step1State: state
    };
}

// *******************************
//  UPDATE STEP 2 STATE
// *******************************

export const updateStep2State = (state) => {
    return dispatch => {
        dispatch(updateStep2StateSuccess(state));
    };
}

export const updateStep2StateSuccess = (state) => {
    return  {
        type: UPDATE_STEP_2_STATE,
        step2State: state
    };
}

// *******************************
//  UPDATE STEP 3 STATE
// *******************************

export const updateStep3State = (state) => {
    return dispatch => {
        dispatch(updateStep3StateSuccess(state));
    };
}

export const updateStep3StateSuccess = (state) => {
    return  {
        type: UPDATE_STEP_3_STATE,
        step3State: state
    };
}

// *******************************
//  UPDATE STEP 4 STATE
// *******************************

export const updateStep4State = (state) => {
    return dispatch => {
        dispatch(updateStep4StateSuccess(state));
    };
}

export const updateStep4StateSuccess = (state) => {
    return  {
        type: UPDATE_STEP_4_STATE,
        step4State: state
    };
}

// *******************************
//  UPDATE STEP 5 STATE
// *******************************

export const updateStep5State = (state) => {
    return dispatch => {
        dispatch(updateStep5StateSuccess(state));
    };
}

export const updateStep5StateSuccess = (state) => {
    return  {
        type: UPDATE_STEP_5_STATE,
        step5State: state
    };
}

// *******************************
//  UPDATE STEP 6 STATE
// *******************************

export const updateStep6State = (state) => {
    return dispatch => {
        dispatch(updateStep6StateSuccess(state));
    };
}

export const updateStep6StateSuccess = (state) => {
    return  {
        type: UPDATE_STEP_6_STATE,
        step6State: state
    };
}

// *******************************
//  UPDATE STEP 7 STATE
// *******************************

export const updateStep7State = (state) => {
    return dispatch => {
        dispatch(updateStep7StateSuccess(state));
    };
}

export const updateStep7StateSuccess = (state) => {
    return  {
        type: UPDATE_STEP_7_STATE,
        step7State: state
    };
}

// *******************************
//  UPDATE STEP 8 STATE
// *******************************

export const updateStep8State = (state) => {
    return dispatch => {
        dispatch(updateStep8StateSuccess(state));
    };
}

export const updateStep8StateSuccess = (state) => {
    return  {
        type: UPDATE_STEP_8_STATE,
        step8State: state
    };
}

// *******************************
//  UPDATE STEP 9 STATE
// *******************************

export const updateStep9State = (state) => {
    return dispatch => {
        dispatch(updateStep9StateSuccess(state));
    };
}

export const updateStep9StateSuccess = (state) => {
    return  {
        type: UPDATE_STEP_9_STATE,
        step9State: state
    };
}

// *******************************
//  UPDATE STEP 10 STATE
// *******************************

export const updateStep10State = (state) => {
    return dispatch => {
        dispatch(updateStep10StateSuccess(state));
    };
}

export const updateStep10StateSuccess = (state) => {
    return  {
        type: UPDATE_STEP_10_STATE,
        step10State: state
    };
}

// *******************************
//  UPDATE STEP 1 STATE
// *******************************

export const updateStep11State = (state) => {
    return dispatch => {
        dispatch(updateStep11StateSuccess(state));
    };
}

export const updateStep11StateSuccess = (state) => {
    return  {
        type: UPDATE_STEP_11_STATE,
        step11State: state
    };
}